
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiParametriGlobaliGrid extends Serenity.EntityGrid<UtentiParametriGlobaliRow, any> {
        protected getColumnsKey() { return UtentiParametriGlobaliColumns.columnsKey; }
        protected getDialogType() { return UtentiParametriGlobaliDialog; }
        protected getIdProperty() { return UtentiParametriGlobaliRow.idProperty; }
        protected getInsertPermission() { return UtentiParametriGlobaliRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiParametriGlobaliRow.localTextPrefix; }
        protected getService() { return UtentiParametriGlobaliService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}